import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import MvpBanner from "../component/banner/MvpBanner";
import MvpIndustry from "../component/mvp/MvpIndustry";
import MvpServices from "../component/mvp/MvpServices";
import MvpWhyChooseUs from "../component/mvp/MvpWhyChooseUs";
import MvpSuccessStories from "../component/mvp/MvpSuccessStories";
import MvpProcess from "../component/mvp/MvpProcess";
import MvpFaq from "../component/mvp/MvpFaq";
import MvpCta from "../component/mvp/MvpCta";
import MvpBrands from "../component/mvp/MvpBrands";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";

import seoData from "../seoData/MvpPage.json";

const MvpPage = () => {
  return (
    <>
      <SEO {...seoData} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <MvpBanner />
        <MvpIndustry />
        <MvpServices />
        <MvpWhyChooseUs />
        <MvpSuccessStories />
        <MvpProcess />
        <MvpFaq />
        <MvpCta />
        <MvpBrands />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default MvpPage;
